import React, { Component } from "react";
import Routes from "./routes";

import * as Sentry from "@sentry/react";
import { Integrations as TracingIntegrations } from "@sentry/tracing"; // Must import after @sentry/react

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_KEY,
  integrations: [new TracingIntegrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release: process.env.REACT_APP_SENTRY_RELEASE,
});

class App extends Component {
  render() {
    return (
      <div>
        <Routes />
      </div>
    );
  }
}

export default Sentry.withProfiler(App);



// WEBPACK FOOTER //
// src/App.js